export default __webpack_public_path__ + "static/media/Seguimiento_6.5736a801.svg";